import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import UserGemsService from "./user.gems.service";
import moment from "moment";
import axios from "axios";
import { nextOccurrenceCell, recurringMarkerCell } from "../helpers/schedule-column";
import { DOMAIN } from "./domain-constant";
import { AppIcons } from "../constants/app-icons";
export default class CalendarEventService extends ApiService {
  namespace = "calendar-event";
  listingRelations = "schedulars,nextOccurrence";
  relations =
    "?expand=schedulars,nextOccurrence,updates,eventColor,ownerName,updates.ownerName,people.display_name,peopleSimple";
  icon = "Calendar";
  singular = this.terminology.event.singular;
  plural = this.terminology.event.plural;
  vowel = this.terminology.event.vowel;
  enableSchedular = true;
  favicon = "Calendar";
  Width = 900;
  action = "action";
  DOMAIN = DOMAIN.CALENDAR_EVENT;
  enablesSchedular = true;
  labelKey = "title";
  gemItems = [
    {
      // this.parse("employee")
      key: "create",
      label: this.t("addAnEntity", { entity: this.singular }),

      icon: AppIcons.PLUS,
    },
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.LIST,
    },
    {
      key: "loader",
      label: this.t("emailEntity", { entity: this.plural }),
      services: DOMAIN.VENDOR,
      icon: AppIcons.MAIL,
    },
    {
      key: "create",
      label: this.t("generateReport"),
      icon: AppIcons.DOCUMENT,
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "Open this Event",
      icon: AppIcons.EDIT,
    },
    {
      key: "announce",
      label: "announceThisEntity",
      services: DOMAIN.MESSAGES,
      icon: AppIcons.LIST,
    },
    {
      key: "email",
      label: "emailThisEntity",
      icon: AppIcons.MAIL,
    },
    {
      key: "bookmark",
      label: "bookmarkThisEntity",
      icon: AppIcons.BOOKMARK,
    },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Add a new record",
      icon: AppIcons.LIST,
    },
  ];
  columns = [
    {
      header: "",
      field: "recurring_id",
      width: "2",
      template: (data) => recurringMarkerCell(data),
    },
    {
      header: "Calendar",
      icon: AppIcons.CALENDAR,
      field: "calendar",
    },
    {
      header: "Event",
      icon: AppIcons.CALENDAR,
      field: "title",
    },
    {
      header: "Date",
      icon: AppIcons.GREEN_CALENDAR,
      field: "date",
      template: (data) => {
        return moment(String(data.start)).format("MM/DD/YYYY");
      },
    },
    {
      header: this.t("nextOccurrence"),
      icon: AppIcons.REPEAT,
      field: "nextOccurrence",
      template: (data) => nextOccurrenceCell(data),
    },
  ];
  listingFooterControls = [
    {
      key: "employee.add",
      label: "Add People",
      icon: AppIcons.PLUS,
      action: (selectedItems, btn, event) => {
        let oldLabel = btn.label;
        selectedItems.forEach(() => {
          btn.label = "adding people...";
          let userGemsService = new UserGemsService();
          let people = {};
          userGemsService.post(people).then(() => {
            btn.label = oldLabel;
            this.emitter.emit("close-window", event);
          });
        });
      },
    },
  ];
  constructor() {
    super("events");
  }
  getName(obj) {
    return this.store
      .dispatch("fetch/refresh", {
        serviceId: obj.service.DOMAIN,
        data: obj.data,
        service: obj.service,
      })
      .then((response) => {
        let items = response[obj.service.DOMAIN];
        let name = null;
        if (obj.id) {
          name = items.find((x) => x.id === obj.id).display_name;
        }
        return name;
      });
  }
  getEvents(date, calendar) {
    return this.all({
      expand: "eventColor,updates",
      date: date,
      calendar: calendar,
    }).then((d) => {
      return d;
    });
  }
  postEvents(service, data, color) {
    let axiosArray = [];
    data.forEach((element) => {
      let postData = {};
      postData["id"] = element.id;
      postData["color"] = color;
      let newPromise = service.save(postData);
      axiosArray.push(newPromise);
    });

    return axios.all(axiosArray).then(
      axios.spread((...responses) => {
        // responses.forEach((res) => {
        //   return res;
        // });

        return responses;
      })
    );

    //   let axiosArray = [];
    //   data.forEach((element) => {
    //     let newPromise = {
    //       id: element.id,
    //       color: "782F16",
    //     };
    //     axiosArray.push(newPromise);
    //   });
    //   return service.all(axiosArray).then(
    //     axios.spread((...responses) => {
    //       responses.forEach((res) => {});
    //     })
    //   );
  }
}
